import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/sharing.svg'


const _withScopeId = n => (_pushScopeId("data-v-996e2134"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = {
  key: 1,
  class: "container_content"
}
const _hoisted_4 = { class: "content_phone" }
const _hoisted_5 = { class: "phone_img" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bgimg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "cv_banner_img",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "phone_upload" }
const _hoisted_8 = { class: "phone_head" }
const _hoisted_9 = { class: "head_txt" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "studio_title" }, "直播间标题", -1))
const _hoisted_11 = { class: "phone_load" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "phone_text" }
const _hoisted_15 = { class: "text_input" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_head" }, "微信分享:", -1))
const _hoisted_17 = { class: "input_area" }
const _hoisted_18 = { class: "text_upload" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_head" }, "缩略图:", -1))
const _hoisted_20 = { class: "thum_bnail" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant_upload_text" }, "上传Logo", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "建议大小为90*90，大小不能超过2M", -1))
const _hoisted_23 = { class: "text_input" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_head" }, "小标题:", -1))
const _hoisted_25 = { class: "input_area" }
const _hoisted_26 = { class: "text_btn" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_head" }, null, -1))
const _hoisted_28 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_c_upload = _resolveComponent("c-upload")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 分享设置 "),
        _createVNode(_component_a_switch, {
          class: "btns_txt",
          checkedValue: 0,
          unCheckedValue: 1,
          checked: _ctx.obj.status,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.obj.status) = $event)),
          onChange: _ctx.DownClose
        }, null, 8, ["checked", "onChange"])
      ]),
      (_ctx.showLoading)
        ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(_ctx.obj.content), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.imageUrl,
                          alt: ""
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.obj.status,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.obj.status) = $event)),
                    onChange: _ctx.DownClose,
                    name: "radioGroup"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("启用")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("关闭")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_c_upload, {
                    "file-list": _ctx.fileList,
                    "handle-change": _ctx.handleChange,
                    loading: _ctx.loading,
                    "image-name": _ctx.imageUrl,
                    "click-stop": _ctx.imageDel,
                    class: "ant_upload"
                  }, {
                    uploadImg: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
                  _hoisted_22
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_a_textarea, {
                    class: "area_tex",
                    value: _ctx.obj.content,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.obj.content) = $event)),
                    showCount: "",
                    defaultValue: "1",
                    maxlength: 50,
                    "auto-size": { minRows: 5, maxRows: 5 }
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _ctx.DownClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ]))
    ])
  ], 64))
}